import React from "react";
import "./styles/index.scss";
import { InvestorAvatar } from "../../investorsDeals/DealInvestors/investorAvatar";
import { currencyFormat } from "../../../../helpers/utils";
import * as api from "../../../../api/generated-api";
import Button from "../../../common/forms/button";

type InvestorViewBaseFormProps = {
  investor: api.DealInvestor;
  dealLegalEntityInvestments: api.DealLegalEntityInvestment[];
  onAddAddress?: () => void;
  clickToAvatar: (e: any) => void;
  clickToMembers?: (e: any) => void;
};

const InvestorViewBaseForm = (props: InvestorViewBaseFormProps) => {
  const { investor, onAddAddress, clickToAvatar, clickToMembers } = props;

  if (!investor) {
    return null;
  }

  const InvestorAddress = ({ line, city, state, zip }) => {
    if (line && city && state && zip) {
      return (
        <div className="investor-address">
          <div className="investor-address title">Investor Address</div>
          <div
            data-testid="investor-address-line"
            className="investor-address value"
          >{`${line || ""}`}</div>
          <div
            data-testid="investor-address-city-state-zip"
            className="investor-address value"
          >{`${city || ""}, ${state || ""} ${zip || ""}`}</div>
        </div>
      );
    } else if (onAddAddress) {
      return (
        <div className="investor-address">
          <div className="investor-address title">Investor Address</div>
          <div className="investor-address button">
            <Button
              data-testid="investor-address-add-button"
              type="secondary"
              size="small"
              onClick={onAddAddress}
              itemLeft={undefined}
            >
              add
            </Button>
          </div>
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <div className="investor-view-base-form">
      <InvestorAvatar
        label={investor.name?.charAt(0)}
        onClick={clickToAvatar}
      />
      <div className="investor-company-description">
        <div
          data-testid="investor-company-name"
          className="investor-company-name"
        >
          {investor.name}
        </div>
        <div className="investor-company-members" onClick={clickToMembers}>
          {investor.isLead && <div>Lead Investor</div>}
        </div>
      </div>
      <div className="investor-company-amount">
        <div className="investor-company-amount-title">
          Target Investment Amount
        </div>
        <div
          className="investor-company-amount-value"
          data-testid="investor-target-investment-amount"
        >
          {currencyFormat(investor.targetInvestment)}
        </div>
      </div>
      <div className="investor-address-container">
        <InvestorAddress
          line={investor.line}
          city={investor.city}
          state={investor.state}
          zip={investor.zip}
        />
      </div>
    </div>
  );
};

export default InvestorViewBaseForm;
